module.exports = __webpack_public_path__ + "img/nextbuy-sm.691650fe.svg";